import React, { Component } from 'react'
import Auth from '../components/auth'
class Empty extends Component {
    render() {
        return (
            <div>
                服务器开小差了
            </div>
        )
    }
}

export default Auth(Empty)